import React, { useState, useEffect, useRef } from "react";
import {
  Box,
  Typography,
  TableBody,
  TableContainer,
  Snackbar,
  Button,
  Tabs,
  Tab,
  Paper,
  Link,
  Card,
  CardContent,
  Divider,
  CircularProgress,
  Badge,
  Dialog,
  DialogContent,
  DialogActions,
  ButtonGroup,
  Menu,  // <-- Added missing import
  MenuItem,
  TextField,  // <-- Added missing import
} from "@mui/material";
import { IconButton } from "@mui/material";
import NotificationsIcon from "@mui/icons-material/Notifications";
import { styled } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import { useMutation } from "react-query";
import jsPDF from "jspdf";
import "jspdf-autotable";

import { StyledTableRow } from "../../Utils/styledcell";
import client from "../../API"; // your HttpClient queries
import { useIsMounted } from "../../Hooks/use-is-mounted";
import InvoiceDialog from "../Dashboard/invoicing/invoicedialog";
import InvoiceEdit from "../Dashboard/invoicing/editInvoice";
import VendorDialog from "./vendorintake";
import InvoiceActionDialog from "./invoiceaction";
import ClientInvoiceActionDialog from "./clientinvoiceaction";
import ConfirmInvoiceDialog from "./approve-invoice"; // (See #2 below)
import blitzLogo from "../../Components/globalAssets/platty.png";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
// ... other imports
import useAuth from "../../Hooks/use-auth"; // import your auth hook
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { useTheme, useMediaQuery } from '@mui/material';
import SmsInviteDialog from "./extras/blitzpaySMS";
import InvoicesTable from "./tables/invoicesTable";
import ActivityTable from "./tables/activityTable";
import IncomingInvoicesTable from "./tables/incomingInvoices";
import PayoutsTable from "./tables/payoutsTable";
import ActivityView from "./tables/activityView";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ChevronLeftIcon  from "@mui/icons-material/ChevronLeft";

const ActionCardGrid = styled(Box)`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px;
  margin-bottom: 20px;
`;

const StyledCard = styled(Card)`
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  transition: transform 0.3s ease;
  &:hover {
    transform: translateY(-5px);
    box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1);
  }
`;

const BlitzPay = () => {
  const isMounted = useIsMounted();
  const navigate = useNavigate();
  const theme     = useTheme();                         // ← NEW
  const isMobile  = useMediaQuery(theme.breakpoints.down("sm")); // ← NEW

  // --------------- State ---------------
  const [statusFilter, setStatusFilter] = useState("");
  const [creatorFilter, setCreatorFilter] = useState("");
  const [startDate, setStartDate] = useState(
    new Date(new Date().setDate(new Date().getDate() - 365))
      .toISOString()
      .split("T")[0]
  );
  const [endDate, setEndDate] = useState(
    new Date(new Date().setDate(new Date().getDate() + 365))
      .toISOString()
      .split("T")[0]
  );
  const [invoices, setInvoices] = useState([]);
  const [incomingInvoices, setIncomingInvoices] = useState([]);
  const [filteredInvoices, setFilteredInvoices] = useState([]);
  const [campaignNames, setCampaignNames] = useState({});
  const [creatorNames, setCreatorNames] = useState({});
  const [allCreatorIds, setAllCreatorIds] = useState([]);
  const [accountBalance, setAccountBalance] = useState("Loading...");
  const [creditline, setCreditline] = useState("Loading...");
  const [open, setOpen] = useState(false); // create invoice dialog
  const [editOpen, setEditOpen] = useState(false);
  const [currentInvoice, setCurrentInvoice] = useState(null);
  const [plaidLinkToken, setPlaidLinkToken] = useState("");

  // Snackbar
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");

  // Tab index
  const [tabIndex, setTabIndex] = useState(0);

  // Payout states
  const [payouts, setPayouts] = useState([]);
  const [isPayoutsLoading, setIsPayoutsLoading] = useState(true);

  // Vendor Dialog
  const [vendorDialogOpen, setVendorDialogOpen] = useState(false);

  // Approve/Decline (Creator)
  const [actionDialogOpen, setActionDialogOpen] = useState(false);
  const [selectedInvoiceId, setSelectedInvoiceId] = useState(null);

  // Approve/Decline (Client)
  const [clientActionDialogOpen, setClientActionDialogOpen] = useState(false);
  const [selectedClientInvoiceId, setSelectedClientInvoiceId] = useState(null);

  // Confirm Invoice (New)
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
  const [confirmInvoiceId, setConfirmInvoiceId] = useState(null);

  // NEW: Additional state to handle “Multiple Pending Invoices” popup
  const [showPendingWarning, setShowPendingWarning] = useState(false);
  const { getCurrrentUser } = useAuth();
  const currentUser = getCurrrentUser();
  const mobileTabLabels = ["All Activity", "Invoices", "Incoming Invoices", "Payouts"];

  // --------------- Handlers ---------------
  const handleOpenVendorDialog = () => setVendorDialogOpen(true);
  const handleCloseVendorDialog = () => setVendorDialogOpen(false);

  const handleOpenSmsDialog   = () => setSmsDialogOpen(true);
  const handleCloseSmsDialog = () => {
    if (!inviteLoading) {
      setSmsDialogOpen(false);
      setInviteName("");
      setInvitePhone("");
      setInviteAmount("");      // NEW reset
    }
  };
  
  // --- NEW “SMS invite” state ---
  const [smsDialogOpen, setSmsDialogOpen] = useState(false);
  const [inviteName,  setInviteName]  = useState("");
  const [invitePhone, setInvitePhone] = useState("");
  const [inviteLoading, setInviteLoading] = useState(false);

  const [inviteAmount, setInviteAmount] = useState("");
// 🆕 keeps every username from creators.list()
  const [existingCreatorIds, setExistingCreatorIds] = useState([]);
  const [payAnchorEl, setPayAnchorEl] = useState(null);           // NEW – primary menu
  const payMenuOpen = Boolean(payAnchorEl);
// used for de‑dup validation (includes invoices, payouts, PLUS creator list)
const openPayMenu   = (e) => setPayAnchorEl(e.currentTarget);
  const closePayMenu  = () => setPayAnchorEl(null);

  // all creator usernames you already fetched live in `allCreatorIds`
  const { mutate: sendInvite } = useMutation(client.payouts.invite, {
    onSuccess: (data) => {
      setSnackbarMessage(`Invite sent! (${data.count} payout created)`);
      setSnackbarOpen(true);
      setSmsDialogOpen(false);
      setInviteName(""); setInvitePhone("");
    },
    onError: (err) => {
      const msg =
        err?.response?.data?.error || "Failed to send invite. Please try again.";
      setSnackbarMessage(msg);
      setSnackbarOpen(true);
    },
    onSettled: () => setInviteLoading(false),
  });

  

  const handleSendInvite = () => {
    // basic validation
    if (!inviteName.trim() || !invitePhone.trim()) {
      setSnackbarMessage("Creator name and phone are required.");
      setSnackbarOpen(true);
      return;
    }
  
    const amt = parseFloat(inviteAmount);
    if (isNaN(amt) || amt <= 0) {
      setSnackbarMessage("Please enter a valid amount (greater than 0).");
      setSnackbarOpen(true);
      return;
    }
  
    if (allCreatorIds.includes(inviteName.trim())) {
      setSnackbarMessage(
        "That creator already exists. Use the normal “Pay a Creator” button."
      );
      setSnackbarOpen(true);
      return;
    }
  
    setInviteLoading(true);
    sendInvite({
      payouts: [
        {
          creator_name: inviteName.trim(),
          phone_number: invitePhone.trim(),
          amount: amt,                       // ✅ use the value from the dialog
          po_number: `SMS-${Date.now()}`,
        },
      ],
      fee_payer: "creator",
      notes: "SMS invite",
    });
  };
  

  const handleNextMobileTab = () =>
    setTabIndex((prev) => (prev + 1) % mobileTabLabels.length);   // cycles forward
  const handleBackToAll     = () => setTabIndex(0);               // always back to “All Activity”

  const handleCloseInvoiceDialog = () => {
    setOpen(false);
    fetchInvoices();
  };

  const handleEditDialogOpen = (invoice) => {
    setCurrentInvoice(invoice);
    setEditOpen(true);
  };
  const handleEditDialogClose = (refresh = false) => {
    setEditOpen(false);
    setCurrentInvoice(null);
    if (refresh) {
      fetchInvoices();
    }
  };

  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue);
  };

  const handleStartDateChange = (event) => {
    setStartDate(event.target.value);
  };
  const handleEndDateChange = (event) => {
    setEndDate(event.target.value);
  };

  const handleCloseSnackbar = (event, reason) => {
    if (reason === "clickaway") return;
    setSnackbarOpen(false);
  };

  // Approve/Decline (Creator)
  const handleOpenActionDialog = (invoiceId) => {
    setSelectedInvoiceId(invoiceId);
    setActionDialogOpen(true);
  };
  const handleCloseActionDialog = () => {
    setActionDialogOpen(false);
    setSelectedInvoiceId(null);
  };

  // Approve/Decline (Client)
  const handleOpenClientActionDialog = (invoiceId) => {
    setSelectedClientInvoiceId(invoiceId);
    setClientActionDialogOpen(true);
  };
  const handleCloseClientActionDialog = () => {
    setClientActionDialogOpen(false);
    setSelectedClientInvoiceId(null);
  };

  // Confirm Invoice (New)
  const handleOpenConfirmDialog = (invoiceId) => {
    setConfirmInvoiceId(invoiceId);
    setConfirmDialogOpen(true);
  };
  const handleCloseConfirmDialog = () => {
    setConfirmDialogOpen(false);
    setConfirmInvoiceId(null);
  };

  // Common success handler
  const handleActionSuccess = (message) => {
    setSnackbarMessage(message);
    setSnackbarOpen(true);
    fetchIncomingInvoices(); // refresh
    fetchInvoices(); // also refresh standard invoices
  };

  const [anchorEl, setAnchorEl] = useState(null);
  const menuOpen = Boolean(anchorEl);

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleCopyLink = () => {
    // Construct the vendor signup URL using the current user's company name
    const companyName = currentUser?.company_name || "";
    const vendorSignupUrl = `/vendor_signup/${encodeURIComponent(companyName)}`;
    const fullUrl = window.location.origin + vendorSignupUrl;

    navigator.clipboard.writeText(fullUrl)
      .then(() => {
        setSnackbarMessage("Vendor Signup Link copied to clipboard!");
        setSnackbarOpen(true);
      })
      .catch((err) => {
        console.error("Failed to copy link: ", err);
      });
    handleMenuClose();
  };
  // --------------- Helpers ---------------
  const formatAmount = (amount) => {
    const num = parseFloat(amount || 0.0);
    return `$${num.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`;
  };

  const getPaymentName = (invoice) => {
    if (invoice.campaign_id) {
      return campaignNames[invoice.campaign_id] || "Unknown Campaign";
    } else if (invoice.campaign_name) {
      return invoice.campaign_name;
    }
    return "Unknown Payment";
  };

  // --------------- Queries & Mutations ---------------
  const { mutate: fetchCompanyData } = useMutation(client.companies.listFetch, {
    onSuccess: (data) => {
      if (data && data.balance !== undefined && data.credit_line !== undefined) {
        setAccountBalance(`$${parseFloat(data.balance).toFixed(2)}`);
        setCreditline(
          data.credit_line
            ? `$${parseFloat(data.credit_line).toFixed(2)}`
            : "No Credit Line Established"
        );
      } else {
        setAccountBalance("Data format error");
        setCreditline("Data format error");
      }
    },
    onError: (error) => {
      console.error("Error fetching company data:", error);
      setAccountBalance("Error loading balance");
      setCreditline("Error loading credit line");
    },
  });

  const { mutate: fetchInvoices } = useMutation(client.invoices.list, {
    onSuccess: (data) => {
      setInvoices(data.invoices || []);
      const creatorIdsFromInvoices = (data.invoices || [])
        .filter((inv) => inv.creator_id)
        .map((inv) => inv.creator_id);
      setAllCreatorIds((prev) =>
        Array.from(new Set([...prev, ...creatorIdsFromInvoices]))
      );
    },
    onError: (error) => {
      console.error("Error fetching invoices:", error);
    },
  });

  const { mutate: fetchCampaigns } = useMutation(client.campaigns.list, {
    onSuccess: (data) => {
      const map = {};
      data.forEach((c) => {
        if (c) map[c.id] = c.name;
      });
      setCampaignNames(map);
    },
    onError: (err) => console.error("Error fetching campaigns:", err),
  });

  const { mutate: fetchCreators } = useMutation(client.creators.list, {
    onSuccess: (data) => {
      const map = {};
      const ids = [];
      data.forEach((creator) => {
        if (creator) {
          map[creator.id] = creator.name;
          ids.push(creator.id);
        }
      });
      setCreatorNames(map);
      setExistingCreatorIds(ids);

      // 🆕 add to master list so handleSendInvite sees them
      setAllCreatorIds((prev) => Array.from(new Set([...prev, ...ids])));
    },
    onError: (err) => console.error("Error fetching creators:", err),
  });

  const { mutate: fetchAllCreatorIds } = useMutation(client.payouts.list, {
    onSuccess: (data) => {
      const uniqueIds = Array.from(
        new Set(data.payouts.map((p) => p.creator_id))
      );
      setAllCreatorIds((prev) => Array.from(new Set([...prev, ...uniqueIds])));
    },
    onError: (err) => console.error("Error fetching creator IDs:", err),
  });

  const { mutate: fetchIncomingInvoices } = useMutation(
    client.invoices.creatorList,
    {
      onSuccess: (data) => {
        setIncomingInvoices(data.incoming_invoices || []);
      },
      onError: (error) => {
        console.error("Error fetching incoming invoices:", error);
      },
    }
  );

  const { mutate: fetchPayouts } = useMutation(client.payouts.list, {
    onSuccess: (data) => {
      setPayouts(data.payouts || []);
    },
    onError: (error) => {
      console.error("Error fetching payouts:", error);
      let errorMessage = "An error occurred, please try again.";
      if (error.code === "ERR_NETWORK") {
        errorMessage = "Network is disconnected!";
      } else if (error.response && error.response.data) {
        errorMessage = error.response.data.message || errorMessage;
      }
      setSnackbarMessage(errorMessage);
      setSnackbarOpen(true);
    },
    onSettled: () => {
      setIsPayoutsLoading(false);
    },
  });

  // For Approve/Decline (Creator) invoice
  const { mutate: invoiceAction } = useMutation(client.invoices.action, {
    onSuccess: (data) => {
      setSnackbarMessage(data.message || "Action completed successfully.");
      setSnackbarOpen(true);
      fetchIncomingInvoices();
    },
    onError: (error) => {
      const errMsg =
        error.response?.data?.error || "Error performing invoice action.";
      setSnackbarMessage(errMsg);
      setSnackbarOpen(true);
    },
  });

  // For Approve/Decline (Client) invoice
  const { mutate: clientInvoiceAction } = useMutation(
    ({ invoiceId, action }) => client.invoices.clientAction({ invoiceId, action }),
    {
      onSuccess: (data) => {
        setSnackbarMessage(data.message || "Client invoice action completed.");
        setSnackbarOpen(true);
        fetchIncomingInvoices();
      },
      onError: (error) => {
        const errMsg =
          error.response?.data?.error ||
          "Error performing client invoice action.";
        setSnackbarMessage(errMsg);
        setSnackbarOpen(true);
      },
    }
  );

  // Confirm Invoice
  const { mutate: confirmInvoice } = useMutation(client.invoices.confirmInvoice, {
    onSuccess: (data) => {
      handleActionSuccess(data.message || "Invoice confirmed successfully.");
    },
    onError: (error) => {
      const errMsg =
        error.response?.data?.error || "Error confirming the invoice.";
      setSnackbarMessage(errMsg);
      setSnackbarOpen(true);
    },
  });

  // --------------- Effects ---------------
  useEffect(() => {
    if (!isMounted) return;
    fetchCompanyData();
    fetchInvoices();
    fetchCampaigns();
    fetchCreators();
    fetchAllCreatorIds();
    fetchIncomingInvoices();
    fetchPayouts();
  }, [isMounted]);

  useEffect(() => {
    setFilteredInvoices(
      invoices.filter(
        (invoice) =>
          (statusFilter === "" || invoice.status === statusFilter) &&
          (creatorFilter === "" || invoice.creator_id === creatorFilter) &&
          new Date(invoice.created_at) >= new Date(startDate) &&
          new Date(invoice.created_at) <= new Date(endDate)
      )
    );
  }, [invoices, statusFilter, creatorFilter, startDate, endDate]);

  // Example Plaid Link usage
  useEffect(() => {
    const fetchLinkTokenUser = async () => {
      try {
        const resp = await client.bank.getLinkTokenUser();
        setPlaidLinkToken(resp.link_token);
      } catch (err) {
        console.error("Error fetching user link token:", err);
      }
    };
    fetchLinkTokenUser();
  }, []);

  // NEW: Watch for 2 or more pending invoices => show popup
  useEffect(() => {
    // Combine normal and incoming if you want to block any "pending" invoice
    // OR just check the main "invoices" array. Adjust as needed.
    const totalPending = invoices.filter((inv) => inv.status === "pending").length;

    // If you also want to include incomingInvoices in that count, then:
    // const totalPending =
    //   invoices.filter((inv) => inv.status === "pending").length +
    //   incomingInvoices.filter((inv) => inv.invoice_status === "pending").length;

    if (totalPending >= 2) {
      setShowPendingWarning(true);
    } else {
      setShowPendingWarning(false);
    }
  }, [invoices, incomingInvoices]);

  // --------------- Plaid Bank Link (example) ---------------
  const handleLinkBankAccount = async () => {
    const userId = 123; // example ID

    if (!plaidLinkToken) {
      alert("No link token found. Please try again later.");
      return;
    }
    if (!window.Plaid) {
      alert(
        "Plaid script not loaded. Ensure <script src='https://cdn.plaid.com/link/v2/stable/link-initialize.js'/> is present."
      );
      return;
    }

    const plaidHandler = window.Plaid.create({
      token: plaidLinkToken,
      onSuccess: async (public_token) => {
        try {
          await client.bank.userLink({
            public_token,
            entity_type: "user",
            entity_id: userId,
          });
          setSnackbarMessage("Bank account linked successfully!");
          setSnackbarOpen(true);
        } catch (err) {
          console.error("Error linking bank account:", err);
          alert(`Error linking bank account: ${err.message}`);
        }
      },
      onExit: (err) => {
        if (err) {
          console.error("Plaid Link exited with error:", err);
        } else {
          console.log("Plaid Link exited by user");
        }
      },
    });

    plaidHandler.open();
  };

  // --------------- Summaries ---------------
  const totalInvoices = invoices.length;
  const invoicesByStatus = invoices.reduce((acc, invoice) => {
    acc[invoice.status] = (acc[invoice.status] || 0) + 1;
    return acc;
  }, {});

  const creatorsPaid = payouts.length;
  const amountInEscrow = payouts.reduce((acc, curr) => {
    if (["pending", "queued"].includes((curr.status || "").toLowerCase())) {
      return acc + curr.amount;
    } else {
      return acc;
    }
  }, 0);
  const paymentsThisMonth = payouts.reduce((acc, curr) => {
    const payoutDate = new Date(curr.payout_date);
    const currentMonth = new Date().getMonth();
    const currentYear = new Date().getFullYear();
    if (
      payoutDate.getMonth() === currentMonth &&
      payoutDate.getFullYear() === currentYear
    ) {
      return acc + curr.amount;
    }
    return acc;
  }, 0);
  const averagePaymentAmount =
    payouts.length > 0
      ? payouts.reduce((acc, curr) => acc + curr.amount, 0) / payouts.length
      : 0;

  // --------------- PDF Download ---------------
  const downloadPDF = () => {
    const pdf = new jsPDF("p", "mm", "a4");
    const pdfWidth = pdf.internal.pageSize.getWidth();

    // Header background
    pdf.setFillColor(0, 0, 0);
    pdf.rect(0, 0, pdfWidth, 30, "F");

    // Logo
    pdf.addImage(blitzLogo, "PNG", 10, 5, 50, 20);

    // Title
    pdf.setFontSize(18);
    pdf.setTextColor(255, 255, 255);
    pdf.setFont("helvetica", "bold");
    pdf.text("Financial Statement", pdfWidth / 2, 20, { align: "center" });

    // Divider
    pdf.setDrawColor(255, 255, 255);
    pdf.line(10, 30, pdfWidth - 10, 30);

    // Timestamp
    const timestamp = new Date().toLocaleString();
    pdf.setFontSize(12);
    pdf.setTextColor(255, 255, 255);
    pdf.text(`Report generated at: ${timestamp}`, 10, 35);

    pdf.setTextColor(0, 0, 0);

    pdf.text(`Account Balance: ${accountBalance}`, 10, 50);
    pdf.text(`Line of Credit: ${creditline}`, 10, 60);

    pdf.autoTable({
      startY: 70,
      head: [["Payment Name", "PO Number", "Amount Due", "Status", "Created At", "Notes"]],
      body: filteredInvoices.map((invoice) => [
        getPaymentName(invoice),
        invoice.po_number || "N/A",
        formatAmount(invoice.amount_due),
        invoice.status,
        new Date(invoice.created_at).toLocaleDateString(),
        invoice.notes || "",
      ]),
      theme: "striped",
      headStyles: { fillColor: [66, 66, 66], textColor: [255, 255, 255] },
      bodyStyles: { fillColor: [230, 230, 230] },
      alternateRowStyles: { fillColor: [240, 240, 240] },
    });

    pdf.save("financial_statement.pdf");
  };

  // --------------- Combine Activity (All Activity tab) ---------------
  // Filter out CANCELLED invoices from the All Activity list
  const invoiceActivityForAllTab = filteredInvoices
    .filter((inv) => inv.status !== "cancelled") // <-- hides cancelled
    .map((inv) => ({
      type: "Invoice",
      name: getPaymentName(inv),
      po_number: inv.po_number || "N/A",
      amount: inv.amount_due,
      status: inv.status,
      date: inv.created_at,
      notes: inv.notes,
      link: `https://www.useblitz.co/invoicing/${inv.id}`,
      // we’ll let them edit if invoice != "Paid"
      editable: inv.status !== "Paid",
      // new: if invoice is pending, we can show an “Approve Invoice” button
      pending: inv.status === "pending",
      invoiceId: inv.id,
    }));

  const payoutActivityForAllTab = payouts
    .filter((p) => {
      const dateCheck =
        new Date(p.payout_date) >= new Date(startDate) &&
        new Date(p.payout_date) <= new Date(endDate);
      const statusCheck = !statusFilter || p.status === statusFilter;
      return dateCheck && statusCheck;
    })
    .map((p) => ({
      type: "Payout",
      name: p.campaignname || "Creator Payout",
      po_number: "N/A",
      amount: p.amount,
      status: p.status,
      date: p.payout_date,
      notes: p.notes,
      link: "#",
      editable: false,
      pending: false,
      invoiceId: null,
    }));

  const combinedActivity = [
    ...invoiceActivityForAllTab,
    ...payoutActivityForAllTab,
  ].sort((a, b) => new Date(b.date) - new Date(a.date));

  // Show # of incoming invoices
  const totalIncomingAmount = incomingInvoices.length;

  // --------------- Render ---------------
  return (
    <>
      <Paper
        elevation={2}
        square={true}
        sx={{ width: "100%", paddingBlockStart: 2, marginBlockEnd: 2 }}
      >
        <Typography
          variant="h4"
          gutterBottom
          component="div"
          sx={{ textAlign: "center", position: "sticky", left: 0 }}
        >
          Your BlitzPay Activity
        </Typography>
  
        <Box
          sx={{
            width: "100%",
            overflowX: "auto",
            paddingInline: { xs: 2, md: 4 },
            marginBlockEnd: 2,
          }}
        >
          <Box display="flex" justifyContent="center" alignItems="center" gap={2} flexWrap="wrap" pb={1}>
            <Button variant="contained" color="primary" onClick={() => navigate("/client_invoice")}>
              Create Invoice
            </Button>
  
            <ButtonGroup variant="contained" color="primary">
              <Button onClick={openPayMenu}>Pay&nbsp;Someone</Button>
              <Button size="small" onClick={handleMenuOpen}>
                <ArrowDropDownIcon />
              </Button>
            </ButtonGroup>
  
            <Menu id="pay-menu" anchorEl={payAnchorEl} open={payMenuOpen} onClose={closePayMenu}>
              <MenuItem onClick={() => { closePayMenu(); navigate("/pay"); }}>
                Pay&nbsp;Existing&nbsp;Creator
              </MenuItem>
              <MenuItem onClick={() => { closePayMenu(); handleOpenSmsDialog(); }}>
                Pay&nbsp;New&nbsp;Vendor
              </MenuItem>
            </Menu>
  
            <Menu id="side-menu" anchorEl={anchorEl} open={menuOpen} onClose={handleMenuClose}>
              <MenuItem onClick={handleCopyLink}>Copy&nbsp;Link</MenuItem>
              <MenuItem onClick={handleOpenVendorDialog}>Add&nbsp;a&nbsp;Vendor</MenuItem>
            </Menu>
  
            <TextField
              size="small"
              label="Start Date"
              type="date"
              value={startDate}
              onChange={handleStartDateChange}
              InputLabelProps={{ shrink: true }}
              sx={{ minWidth: 240 }}
            />
            <TextField
              size="small"
              label="End Date"
              type="date"
              value={endDate}
              onChange={handleEndDateChange}
              InputLabelProps={{ shrink: true }}
              sx={{ minWidth: 240 }}
            />
  
            <Button
              variant="contained"
              color="secondary"
              onClick={downloadPDF}
              sx={{ minWidth: 240 }}
            >
              Download Statement
            </Button>
          </Box>
        </Box>
  
        {isMobile ? (
        /* ---------- MOBILE HEADER ---------- */
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: 1,
            py: 1,
          }}
        >
          {/* ← back to All Activity */}
          {tabIndex !== 0 && (
            <IconButton size="large" onClick={handleBackToAll}>
              <ChevronLeftIcon />
            </IconButton>
          )}

          {/* current label */}
          <Typography variant="h6" sx={{ textAlign: "center", flexShrink: 0 }}>
            {mobileTabLabels[tabIndex]}
          </Typography>

          {/* → next tab with badge */}
          <IconButton size="large" onClick={handleNextMobileTab}>
            <Badge
              badgeContent={totalIncomingAmount}
              color="secondary"
              invisible={totalIncomingAmount === 0}
            >
              <ChevronRightIcon />
            </Badge>
          </IconButton>
        </Box>
      ) : (
        /* ---------- DESKTOP TABS ---------- */
        <Tabs value={tabIndex} onChange={handleTabChange} centered>
          <Tab label="All Activity" />
          <Tab label="Invoices" />
          <Tab
            label={
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                Incoming&nbsp;Invoices
                <Badge
                  badgeContent={totalIncomingAmount}
                  color="secondary"
                  anchorOrigin={{ vertical: "top", horizontal: "right" }}
                >
                  <NotificationsIcon />
                </Badge>
              </Box>
            }
          />
          <Tab label="Payouts" />
        </Tabs>
      )}

      </Paper>
  
      {/* MAIN CONTENT CONTAINER */}
      <Box sx={{ 
        display: 'grid', 
        gridTemplateColumns: { xs: '1fr', md: '30% 70%' },
        gap: 3,
        padding: 2
      }}>
        {/* LEFT COLUMN (SUMMARY CARDS - DESKTOP) */}
        <Box sx={{ display: { xs: 'none', md: 'flex' }, flexDirection: 'column', gap: 2 }}>
          <StyledCard>
            <CardContent>
              <Typography variant="h6" sx={{ mb: 1 }}>Invoice Summary</Typography>
              <Divider sx={{ mb: 2 }} />
              <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 1 }}>
                <Typography variant="body2">Account Balance:</Typography>
                <Typography variant="body2" align="right">{accountBalance}</Typography>
                
                <Typography variant="body2">Line of Credit:</Typography>
                <Typography variant="body2" align="right">{creditline}</Typography>
                
                <Typography variant="body2">Total Invoices:</Typography>
                <Typography variant="body2" align="right">{totalInvoices}</Typography>
                
                {Object.entries(invoicesByStatus).map(([status, count]) => (
                  <React.Fragment key={status}>
                    <Typography variant="body2">{status}:</Typography>
                    <Typography variant="body2" align="right">{count}</Typography>
                  </React.Fragment>
                ))}
              </Box>
            </CardContent>
          </StyledCard>
  
          <StyledCard>
            <CardContent>
              <Typography variant="h6" sx={{ mb: 1 }}>Payout Summary</Typography>
              <Divider sx={{ mb: 2 }} />
              <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 1 }}>
                <Typography variant="body2">Creators Paid:</Typography>
                <Typography variant="body2" align="right">{creatorsPaid}</Typography>
                
                <Typography variant="body2">In Escrow:</Typography>
                <Typography variant="body2" align="right">${amountInEscrow.toFixed(2)}</Typography>
                
                <Typography variant="body2">This Month:</Typography>
                <Typography variant="body2" align="right">${paymentsThisMonth.toFixed(2)}</Typography>
                
                <Typography variant="body2">Avg Payment:</Typography>
                <Typography variant="body2" align="right">${averagePaymentAmount.toFixed(2)}</Typography>
              </Box>
            </CardContent>
          </StyledCard>
        </Box>
  
        {/* RIGHT COLUMN (MAIN CONTENT) */}
        <Box>
          {/* SUMMARY CARDS - MOBILE */}
          <ActionCardGrid sx={{ display: { xs: 'grid', md: 'none' }, mb: 3 }}>
            <StyledCard>
              <CardContent>
                <Typography variant="subtitle1">Invoice Summary</Typography>
                <Divider sx={{ my: 1 }} />
                <Typography variant="body2">Balance: {accountBalance}</Typography>
                <Typography variant="body2">Credit: {creditline}</Typography>
                <Typography variant="body2">Total: {totalInvoices}</Typography>
              </CardContent>
            </StyledCard>
  
            <StyledCard>
              <CardContent>
                <Typography variant="subtitle1">Payout Summary</Typography>
                <Divider sx={{ my: 1 }} />
                <Typography variant="body2">Paid: {creatorsPaid}</Typography>
                <Typography variant="body2">Escrow: ${amountInEscrow.toFixed(2)}</Typography>
                <Typography variant="body2">Month: ${paymentsThisMonth.toFixed(2)}</Typography>
              </CardContent>
            </StyledCard>
          </ActionCardGrid>
  
          {/* TAB CONTENT */}
          {tabIndex === 0 && (
            <ActivityView 
              rows={combinedActivity} 
              isMobile={isMobile}
              onApprove={handleOpenConfirmDialog}
              onEdit={handleEditDialogOpen}
              formatAmount={formatAmount}
            />
          )}
  
          {tabIndex === 1 && (
            <InvoicesTable
              rows={filteredInvoices}
              isMobile={isMobile}
              onEdit={handleEditDialogOpen}
              onConfirm={handleOpenConfirmDialog}
              formatAmount={formatAmount}
              getPaymentName={getPaymentName}
            />
          )}
  
          {tabIndex === 2 && (
            <IncomingInvoicesTable
              rows={incomingInvoices}
              isMobile={isMobile}
              onCreatorAction={handleOpenActionDialog}
              onClientAction={handleOpenClientActionDialog}
              formatAmount={formatAmount}
            />
          )}
  
          {tabIndex === 3 && (
            <PayoutsTable
              rows={payouts.filter(p => {
                const dateCheck = new Date(p.payout_date) >= new Date(startDate) &&
                                  new Date(p.payout_date) <= new Date(endDate);
                const statusCheck = !statusFilter || p.status === statusFilter;
                return dateCheck && statusCheck;
              })}
              isMobile={isMobile}
              isPayoutsLoading={isPayoutsLoading}
              formatAmount={formatAmount}
            />
          )}
        </Box>
      </Box>
  
      {/* DIALOGS AND SNACKBAR */}
      {currentInvoice && (
        <InvoiceEdit
          open={editOpen}
          onClose={handleEditDialogClose}
          invoiceInfo={currentInvoice}
        />
      )}
  
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        message={snackbarMessage}
        action={
          <Button color="inherit" size="small" onClick={handleCloseSnackbar}>
            Close
          </Button>
        }
      />
  
      <VendorDialog open={vendorDialogOpen} onClose={handleCloseVendorDialog} />
      <InvoiceActionDialog
        open={actionDialogOpen}
        onClose={handleCloseActionDialog}
        invoiceId={selectedInvoiceId}
        onSuccess={handleActionSuccess}
        invoiceActionMutation={invoiceAction}
      />
      <ClientInvoiceActionDialog
        open={clientActionDialogOpen}
        onClose={handleCloseClientActionDialog}
        invoiceId={selectedClientInvoiceId}
        onSuccess={handleActionSuccess}
        clientInvoiceActionMutation={clientInvoiceAction}
      />
      <ConfirmInvoiceDialog
        open={confirmDialogOpen}
        onClose={handleCloseConfirmDialog}
        invoiceId={confirmInvoiceId}
        onSuccess={handleActionSuccess}
        confirmInvoiceMutation={confirmInvoice}
      />
      <Dialog open={showPendingWarning} onClose={() => setShowPendingWarning(false)}>
        <DialogContent>
          <Typography>
            Please confirm your other invoices before continuing to use Blitz.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setShowPendingWarning(false)} autoFocus>
            Okay
          </Button>
        </DialogActions>
      </Dialog>
      <SmsInviteDialog
        open={smsDialogOpen}
        onClose={handleCloseSmsDialog}
        loading={inviteLoading}
        onSend={handleSendInvite}
        inviteName={inviteName}
        setInviteName={setInviteName}
        invitePhone={invitePhone}
        setInvitePhone={setInvitePhone}
        inviteAmount={inviteAmount}
        setInviteAmount={setInviteAmount}
      />
    </>
  );
 }

export default BlitzPay;
